import React, { useEffect } from "react"
import images from "themes/images"
import { baseUrlImg } from "../../../config/api"
import { MainActions, AuthActions } from "redux-store/models"
import { connect } from "react-redux"

const AdminWallet = ({
  accountInfo,
  getProviders,
  providers,
  getContiGiocoServices,
  contiGiocoServices,
}) => {
  useEffect(() => {
    getProviders()
    getContiGiocoServices()
  }, [getProviders])

  console.log(contiGiocoServices)

  if (accountInfo?.profile?.role?.name === "main_admin") {
    return (
      <div className="admin-wallets">
        <div className="admin-wallets-carousel">
          {providers
            .filter((provider) => provider.name !== "Exalogic")
            .map((provider, i) => {
              const exactIcon = `${baseUrlImg}/icon/${provider?.name}-icon.svg`
              const lowerIcon = `${baseUrlImg}/icon/${provider?.name.toLowerCase()}-icon.svg`
              const defaultIcon = `${baseUrlImg}/logo/default.jpeg`

              return (
                <div key={i}>
                  <img
                    src={exactIcon}
                    alt={`${provider?.name} logo`}
                    onError={(e) => {
                      const img = e.currentTarget
                      if (img.src !== lowerIcon) {
                        img.src = lowerIcon
                      } else {
                        img.src = defaultIcon
                      }
                    }}
                  />
                  <span>&euro; {parseFloat(provider.wallet).toFixed(2)}</span>
                </div>
              )
            })}

          {Array.isArray(contiGiocoServices) &&
            [
              ...new Map(
                contiGiocoServices.map((item) => [item.company_id, item])
              ).values(),
            ].map((provider, i) => (
              <div key={provider.company_id}>
                <img
                  src={`${baseUrlImg}/icon/${provider?.company?.name}-icon.svg`}
                  alt={`${provider?.company?.name}`}
                />
                <span>&euro; {parseFloat(provider.wallet).toFixed(2)}</span>
              </div>
            ))}
        </div>
      </div>
    )
  }
  return null
}

const mapStateToProps = (state) => ({
  screenWidth: state.main.screenWidth,
  providers: state.main.providers,
  contiGiocoServices: state.auth.contiGiocoServices,
})

export default connect(mapStateToProps, { ...AuthActions, ...MainActions })(
  AdminWallet
)
